import { render } from "./Spells.vue?vue&type=template&id=ba87adfe&scoped=true"
import script from "./Spells.vue?vue&type=script&lang=js"
export * from "./Spells.vue?vue&type=script&lang=js"

import "./Spells.vue?vue&type=style&index=0&id=ba87adfe&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba87adfe"]])

export default __exports__